<template>
  <v-card class="mx-auto pa-4">
    <v-system-bar dark color="grey darken-1" height="50">
      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      Utilisateurs
      <v-spacer></v-spacer>

      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>
    <v-data-table
      :headers="headers"
      :items="users"
      sort-by="email"
      class="elevation-0"
    >
      <template v-slot:top>
        <v-dialog v-model="dialog" max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="ma-2" v-on="on" rounded>
              <v-icon left dark> mdi-plus-circle-outline </v-icon>Nouvel
              Utilisateur</v-btn
            >
          </template>
          <v-form ref="form_new_user" v-model="valid" lazy-validation>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-text-field
                      dense
                      v-model="prenom"
                      label="Prénom"
                      prepend-icon="person"
                      :rules="nameRules"
                      required
                    ></v-text-field>

                    <v-text-field
                      dense
                      v-model="nom"
                      label="Nom"
                      prepend-icon="person"
                      :rules="nameRules"
                      required
                    ></v-text-field>

                    <v-text-field
                      dense
                      v-model="email"
                      :label="$lang.emailAddress"
                      prepend-icon="email"
                      :rules="emailRules"
                      required
                    ></v-text-field>

                    <v-text-field
                      dense
                      v-model="password"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show1 ? 'text' : 'password'"
                      name="input-10-1"
                      :label="$lang.password"
                      hint="Au mois 8 caractères"
                      counter
                      @click:append="show1 = !show1"
                      prepend-icon="mdi-textbox-password"
                      required
                      :rules="nameRules"
                    ></v-text-field>
                  </v-row>
                  <template>
                    <v-row>
                      <!-- <v-col>
                            <v-switch
                              v-if="isSuperAdmin"
                              v-model="roles"
                              label="Super Administrateur"
                              value="superAdmin"
                              sm="8"
                              md="2"
                              @change="setRoles()"
                            ></v-switch>
                          </v-col> -->

                      <v-switch
                        dense
                        v-model="roles"
                        label="Administrateur"
                        value="admin"
                        class="mx-2"
                        sm="8"
                        md="2"
                        @change="setRoles()"
                      ></v-switch>
                    </v-row>
                    <v-row>
                      <v-switch
                        dense
                        v-model="roles"
                        label="Supeviseur"
                        value="superviseur"
                        class="mx-2"
                        sm="8"
                        md="2"
                        @change="setRoles()"
                      ></v-switch>

                      <!--   <v-col>
                            <v-switch
                              v-model="roles"
                              label="Groupe"
                              value="groupe"
                              class="mx-2"
                              sm="8"
                              md="2"
                              @change="setRoles()"
                            ></v-switch>
                          </v-col> -->
                    </v-row>

                    <template v-if="showlocalisation">
                      <v-row>
                        <v-col>
                          <v-row>
                            <v-select
                              dense
                              @change="setRegions()"
                              :rules="[(v) => !!v || 'Item is required']"
                              :items="provinces"
                              label="Provinces"
                              item-value="id_province"
                              item-text="ll_province"
                              filled
                              v-model="province_selected"
                              required
                              ref="province_selected"
                            ></v-select>
                          </v-row>
                        </v-col>
                        <v-col v-if="showRegions">
                          <v-row>
                            <v-select
                              multiple
                              dense
                              @change="setDistricts()"
                              :rules="[(v) => !!v || 'Item is required']"
                              :items="regions"
                              label="Régions"
                              item-value="id_region"
                              item-text="ll_region"
                              filled
                              v-model="region_selected"
                              required
                              ref="region_selected"
                              :loading="districtLoading"
                            >
                            </v-select
                          ></v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col v-if="showDistricts">
                          <v-row>
                            <v-select
                              multiple
                              dense
                              :rules="[(v) => !!v || 'Item is required']"
                              :items="districts"
                              label="Districts"
                              item-value="id"
                              item-text="ll_district"
                              filled
                              v-model="district_selected"
                              required
                              ref="district_selected"
                              :loading="communeLoading"
                              return-object
                            >
                            </v-select
                          ></v-row>
                        </v-col>
                        <v-col v-if="showCommunes">
                          <v-row>
                            <v-select
                              dense
                              @change="setFokontanys()"
                              :rules="[(v) => !!v || 'Item is required']"
                              :items="communes"
                              label="Communes"
                              item-value="id"
                              item-text="ll_commune"
                              filled
                              required
                              v-model="commune_selected"
                              ref="commune_selected"
                              :loading="fokontanyLoading"
                            >
                            </v-select
                          ></v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col v-if="showFokontanys">
                          <v-row>
                            <v-select
                              dense
                              @change="emptyNewFokontany()"
                              :items="fokontanys"
                              :rules="[(v) => !!v || 'Item is required']"
                              label="Fokontany"
                              item-value="id"
                              item-text="ll_fokontany"
                              filled
                              required
                              v-model="fokontany_selected"
                              ref="fokontany_selected"
                            >
                            </v-select
                          ></v-row>
                        </v-col>
                        <v-col v-if="showNewFokontany">
                          <v-row>
                            <v-text-field
                              v-model="new_fokontany"
                              label="Nouveau Fokontany"
                              prepend-icon="map"
                              required
                              :counter="10"
                              :rules="nameRules"
                            ></v-text-field>
                            <v-btn
                              color="success"
                              dark
                              @click="insertNewFokontany"
                              :loading="newFokontanyloader"
                              >Insérer Fokontany</v-btn
                            >
                          </v-row>
                        </v-col>
                        <v-col>
                          <v-row>
                            <template v-if="showlocalisation">
                              <v-container fluid>
                                <v-row>
                                  <v-col cols="12">
                                    <v-select
                                      v-model="projetsSelected"
                                      :items="fusionProjets(projets)"
                                      label="Selectionnez les projets"
                                      multiple
                                      persistent-hint
                                      item-text="ll_programme"
                                      return-object
                                    ></v-select>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </template>
                          </v-row>
                        </v-col>
                      </v-row>
                    </template>
                  </template>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn rounded color="warning" dark @click="resetNewUserForm"
                  >Annuler</v-btn
                >
                <v-btn
                  rounded
                  :loading="newUserLoading"
                  color="primary"
                  dark
                  @click="createUser"
                  >Créer Utilisateur</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </template>
      <!--  <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
      </template> -->
    </v-data-table>
  </v-card>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data: () => ({
    NextpageToKen: "",
    newFokontanyloader: false,
    districtLoading: false,
    communeLoading: false,
    fokontanyLoading: false,
    newUserLoading: false,
    valid: true,
    nameRules: [
      (v) => !!v || "requis",
      (v) => (v && v.length >= 3) || "Au moins trois caractères",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mailrequis",
      (v) => /.+@.+\..+/.test(v) || "E-mail invalide",
    ],
    provinces: [],
    regions: [],
    districts: [],
    communes: [],
    fokontanys: [],
    new_fokontany: "",
    Fokontanydata: "",

    showlocalisation: false,
    showRegions: false,
    showDistricts: false,
    showCommunes: false,
    showFokontanys: false,
    showNewFokontany: false,

    province_selected: "",
    region_selected: "",
    district_selected: "",
    commune_selected: "",
    fokontany_selected: "",
    projetsSelected: [],

    nom: "",
    prenom: "",
    email: "",
    password: "",
    roles: [],
    show1: false,
    dialog: false,
    headers: [
      { text: "ID", value: "uid" },
      {
        text: "Email",
        align: "start",
        value: "email",
      },
      { text: "Roles", value: "uid", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],

    editedIndex: -1,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Nouvel Utilisateur"
        : "Editer Utilisateur";
    },
    ...mapState({
      isAuthenticated: (state) => state.Auth.isAuthenticated,
      isSuperAdmin: (state) => state.Auth.isSuperAdmin,
      isAdmin: (state) => state.Auth.isAdmin,
      isSuperviseur: (state) => Auth.auth.isSuperviseur,
      isGroupe: (state) => state.Auth.isGroupe,
      user: (state) => state.Auth.user,
      users: (state) => state.Users.users,
      projets: (state) => state.Projets.projets,
    }),
  },

  watch: {
    dialog(val) {
      val || this.resetNewUserForm();
    },
  },

  created() {
    if (!this.isAdmin) {
      this.$router.push("/");
    }
    var self = this;

    this.roles = [];
    this.GetUsers();
    this.GetIdentifiants();
    this.GetAllProjects();

    this.provinces = this.$provinces;
    this.regions = [];
  },

  methods: {
    ...mapActions({
      GetIdentifiants: "Users/getAll",
      GetUsers: "Users/getAllUsers",
      GetAllProjects: "Projets/getListeProjets",
    }),
    fusionProjets(projets) {
      let self = this;
      const userProjets = this.user.projets;
      const listeProjets = this.projets;
      const userProjetsArray = [];
      const newProjets = [];
      /*  _.forEach(userProjets, function (item, index) {
        userProjetsArray[index] = item.id_programme;
      });
      console.log(userProjets);

      _.forEach(listeProjets, function (item, index) {
          if (_.includes(userProjetsArray, item.id)) {
          item.checked = true;
        } 

       

        //item.parcoursEffectif = self.parcoursEffectif;
        //item.parcours_effecctif_id_parcours_effectif = self.id;
        newProjets.push(item);
      });
      // return listeEtapes;

       //console.log(newProjets); */

      return listeProjets;
    },
    addProjectToUser() {
      let self = this;
      let projetsSelectednew = [];
      _.forEach(this.projetsSelected, function (item) {
        projetsSelectednew.push({ ...item, id_programme: item.id });
      });
      //console.log(projetsSelectednew);

      var usersRef = this.$firebase
        .firestore()
        .collection("users")
        .doc(this.user.id);
      if (projetsSelectednew.length > 0) {
        usersRef.set(
          {
            projets: projetsSelectednew,
          },
          { merge: true }
        );
      } else {
        console.log("tableau vide");
        usersRef.set({ projets: [] }, { merge: true });
      }
      this.GetIdentifiantsAll();
      this.dialog = false;
    },
    emptyNewFokontany() {
      this.new_fokontany = "---";
      const Fokontanydata = {};
      Fokontanydata["id_fokontany"] = this.fokontany_selected;
      /*  Fokontanydata[
        "ll_fokontany"
      ] = this.$refs.fokontany_selected.selectedItems; */
      Fokontanydata["id_commune"] = parseFloat(this.commune_selected);
      Fokontanydata[
        "ll_commune"
      ] = this.$refs.commune_selected.selectedItems[0].ll_commune;
      Fokontanydata["id_district"] = parseFloat(this.district_selected);
      Fokontanydata[
        "ll_district"
      ] = this.$refs.district_selected.selectedItems[0].ll_district;
      Fokontanydata["id_region"] = parseFloat(this.region_selected);
      Fokontanydata[
        "ll_region"
      ] = this.$refs.region_selected.selectedItems[0].ll_region;
      Fokontanydata["id_province"] = parseFloat(this.province_selected);
      Fokontanydata[
        "ll_province"
      ] = this.$refs.province_selected.selectedItems[0].ll_province;
    },
    setRoles() {
      if (this.roles.includes("superviseur")) {
        this.showlocalisation = true;
      } else {
        this.showlocalisation = false;
      }
      this.regions = [];
    },
    setRegions() {
      var array = this.$regions;
      var regionsFiltrees = array.filter(
        (region) => region.province_id_province === this.province_selected
      );
      this.showRegions = true;
      this.regions = regionsFiltrees;
      this.districts = [];
      this.communes = [];
      this.fokontanys = [];
      this.new_fokontany = "";
      this.showNewFokontany = false;

      this.showDistricts = false;
      this.showCommunes = false;
      this.showFokontanys = false;
    },
    setDistricts() {
      const regionString = this.region_selected.map(String);
      var self = this;
      this.showDistricts = true;
      this.showCommunes = false;
      this.showFokontanys = false;
      this.showNewFokontany = false;
      this.districtLoading = true;
      this.districts = [];
      this.communes = [];
      this.fokontanys = [];
      this.new_fokontany = "";
      this.$firebase
        .firestore()
        .collection("districts")
        .where("regions_id_region", "in", regionString)
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var district = doc.data();
            //console.log(doc.data());
            district.id = doc.id;
            self.districts.push({
              ...district,
            });
            self.districtLoading = false;
          });
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
      //console.log(this.districts);
    },
    setCommunes() {
      var self = this;
      this.communes = [];
      this.fokontanys = [];
      this.new_fokontany = "";
      this.showCommunes = true;
      this.showFokontanys = false;
      this.showNewFokontany = false;
      this.communeLoading = true;

      this.$firebase
        .firestore()
        .collection("communes")
        .where("id_district", "in", [this.district_selected,this.district_selected.toString()])
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var commune = doc.data();
            commune.id = doc.id;
            self.communes.push({
              ...commune,
            });
            self.communeLoading = false;
          });
        });
    },
    setFokontanys() {
      var self = this;
      this.fokontanys = [];
      this.showFokontanys = true;
      this.new_fokontany = "";
      this.fokontanyLoading = true;
      var query = this.$firebase
        .firestore()
        .collection("fokontanys")
        .where("id_commune", "in", [
          this.commune_selected.toString(),
          this.commune_selected,
        ]);

      query.get().then(function (snap) {
        if (snap.empty) {
          //console.log("no documents found");
          self.showNewFokontany = true;
          self.showFokontanys = false;
          self.fokontanyLoading = false;
        } else {
          self.showNewFokontany = true;
          self.showFokontanys = true;
          self.fokontanys = [];
          self.fokontanyLoading = false;

          snap.forEach((doc) => {
            var fokontany = doc.data();
            //console.log(fokontany);
            fokontany.id = doc.id;
            self.fokontanys.push({
              ...fokontany,
            });
          });
        }
      });
    },
    insertNewFokontany() {
      var self = this;
      self.newFokontanyloader = true;
      const Fokontanydata = {};
      Fokontanydata["ll_fokontany"] = this.new_fokontany;
      Fokontanydata["id_commune"] = parseFloat(this.commune_selected);
      Fokontanydata[
        "ll_commune"
      ] = this.$refs.commune_selected.selectedItems[0].ll_commune;
      Fokontanydata["id_district"] = parseFloat(this.district_selected);
      Fokontanydata[
        "ll_district"
      ] = this.$refs.district_selected.selectedItems[0].ll_district;
      Fokontanydata["id_region"] = parseFloat(this.region_selected);
      Fokontanydata[
        "ll_region"
      ] = this.$refs.region_selected.selectedItems[0].ll_region;
      Fokontanydata["id_province"] = parseFloat(this.province_selected);
      Fokontanydata[
        "ll_province"
      ] = this.$refs.province_selected.selectedItems[0].ll_province;
      //console.log(Fokontanydata);
      this.$firebase
        .firestore()
        .collection("fokontanys")
        .add(Fokontanydata)
        .then(function (docRef) {
          //console.log("Document written with ID: ", docRef.id);
          self.showNewFokontany = true;
          self.showFokontanys = true;
          self.fokontany_selected = Fokontanydata;
          self.fokontanys.push({
            ...Fokontanydata,
          });
          self.new_fokontany = "----";
          self.newFokontanyloader = false;
        })
        .catch(function (error) {
          console.error("Error adding document: ", error);
        });
    },
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.desserts.splice(index, 1);
    },
    resetNewUserForm() {
      this.$refs.form_new_user.reset();
      this.dialog = false;
    },
    createUser() {
      let self = this;
      let uuid = "000000000000000aaaa-" + this.$uuid.v4();
      let projetsSelectednew = [];

      _.forEach(this.projetsSelected, function (item) {
        projetsSelectednew.push({ ...item, id_programme: item.id });
      });

      if (this.$refs.form_new_user.validate()) {
        //var self = this;
        this.newUserLoading = true;
        const newDistrictSelected = [];

        _.forEach(this.district_selected, function (item) {
          newDistrictSelected.push({
            ...item,
            id_district: item.id,
          });
        });

        var userAuth = {
          uid: uuid,
          firstName: this.prenom,
          lastName: this.nom,
          password: this.password,
          email: this.email,
          role: this.roles,
          active: 1,
          displayName: this.prenom + " " + this.prenom,
          phone: "",
          user_login: this.email,
          districts: newDistrictSelected,
          projets: projetsSelectednew,
        };
        //console.log(userAuth);

        var createUser = this.$firebase
          .functions()
          .httpsCallable("createUserbySuperAdmin");

        if (this.roles.includes("superviseur")) {
          console.log("superviseur");
          //userAuth.localisation = this.$refs.fokontany_selected.selectedItems[0];
        }

        //send===> user
        createUser(userAuth)
          ///receive <====== resp
          .then(function (resp) {
            //Display success
            //console.log(resp.data.userdata);
            self.users.push(resp.data.userdata);
            self.newUserLoading = false;
            self.resetNewUserForm();
          })
          .catch(function (error) {
            var code = error.code;
            var message = error.message;
            console.log(message);
            self.newUserLoading = false;
            self.resetNewUserForm();
            //Display error
          });

        self.newUserLoading = false;
        self.resetNewUserForm();
      } else {
        //console.clear();
        console.log("Valider d'abord");
      }
    },
  },
};
</script>
